(function () {
  var root = document.documentElement;
  if (!root.classList.contains('gc-site')) return;

  /* Boot loader handles reveal when present */
  if (document.querySelector('[data-gc-boot]')) return;

  root.classList.add('is-loading');

  function reveal() {
    root.classList.remove('is-loading');
    root.classList.add('is-loaded');
  }

  if (document.readyState === 'complete') {
    requestAnimationFrame(reveal);
  } else {
    window.addEventListener('load', function () {
      requestAnimationFrame(reveal);
    }, { once: true });
  }
})();
